
import { Vue } from "vue-class-component";

export default class Delivery extends Vue {}
